<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 107.811 87.512"
    aria-hidden="true"
    data-icon-name="chromecast"
  >
    <path
      d="M1.072 34.077V8.833A8.256 8.256 0 0 1 9.2.5h88.556a8.254 8.254 0 0 1 8.127
        8.333v67.844a8.256 8.256 0 0 1-8.127 8.335H53.923"
      transform="translate(.428 1)"
    />
    <path
      d="M0 21.947c22.956 0 41.566 18 41.566 40.205"
      transform="translate(.213 25.074)"
    />
    <path
      d="M0 29.465a22.608 22.608 0 0 1 22.607 22.607"
      transform="translate(.213 35.154)"
    />
    <path
      d="M0 37.38a5.361 5.361 0 0 1 5.361 5.359"
      transform="translate(.213 44.488)"
    />
  </svg>
</template>

<script>
export default {
  name: 'ChromecastIcon',
};
</script>

<style lang="scss" scoped>
path {
  fill: none;
  stroke: var(--colors-main-font);
  stroke-miterlimit: 10;
  stroke-width: 3px;
}
</style>
